<div *adaptLoading="!input"
     [ngClass]="{'competitor-analysis': isCompetitorAnalysis}">
    <adapt-collapsible-dashboard-element [name]="input!.name"
                                         [isCollapsible]="isCollapsible"
                                         [collapsed]="isCollapsible"
                                         [iconTooltip]="tooltip"
                                         [isExpandable]="!!input!.description"
                                         [overrideStyleClass]="overrideStyleClass"
                                         [iconClass]="iconClass ? iconClass + ' show-icon-on-print' : undefined"
                                         [handleId]="handleId">
        <div *adaptIfAuthorised="EditStrategicInputs"
             adapt-collapsible-header-action-right
             class="d-flex gap-1">
            <button *ngIf="isEditing"
                    adaptButton="editBorderless"
                    adaptTooltip="Edit input"
                    tooltipPlacement="bottom"
                    [adaptBlockingClick]="editInput"
                    [stopPropagation]="true"></button>
            <button *ngIf="isDetachable"
                    class="text-black"
                    adaptButton="deleteBorderless"
                    (click)="onDeleted($event)"
                    adaptTooltip="Detach from strategic working board"
                    tooltipPlacement="bottom"></button>
        </div>
        <div [froalaView]="input!.description"></div>
        <div *ngIf="showCanvasNameInContent && input!.canvas"
             class="d-flex flex-column">
            <span class="canvas-name mt-3">Canvas: {{canvasName}}</span>
            <span class="canvas-name"
                  *ngIf="input?.inputGroup">{{input!.inputGroup!.type}}: {{input!.inputGroup!.name}}</span>
        </div>
    </adapt-collapsible-dashboard-element>
</div>
